//Reset data
export const RESET = "CONVERSATION_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "CONVERSATION_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CONVERSATION_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CONVERSATION_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CONVERSATION_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "CONVERSATION_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CONVERSATION_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CONVERSATION_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CONVERSATION_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CONVERSATION_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "CONVERSATION_CREATE_SET_CREATED"
export const SET_IS_CREATED = "CONVERSATION_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "CONVERSATION_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "CONVERSATION_CREATE_SET_CURRENT_ITEM"
